import React from 'react';
import FlodeskForm from '../FlodeskForm';
import { Mail, CheckCircle } from 'lucide-react';

const NewsletterSection = ({ data }) => {
  // Use custom formId from data if provided, otherwise use default
  const formId = data?.flodesk_form_id || '698ff949955577ffd7fda382';
  const title = data?.section_title || '';
  const subtitle = data?.section_subtitle || '';
  const bottomText = data?.bottom_text || 'Join 40,000+ subscribers already in our community';

  return (
    <section id="newsletter" className="py-24 bg-gray-50" data-testid="newsletter-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
          {/* Header with Icon */}
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-6">
              <Mail className="text-gray-900" size={32} />
            </div>
            {title && (
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-lg text-gray-600">
                {subtitle}
              </p>
            )}
          </div>

          {/* Flodesk Form - Native styling preserved */}
          <div className="flodesk-form-container">
            <FlodeskForm formId={formId} />
          </div>

          {/* Bottom Text with Checkmark */}
          {bottomText && (
            <div className="mt-6 flex items-center justify-center text-sm text-gray-500">
              <CheckCircle size={16} className="mr-2 text-green-500" />
              {bottomText}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
